import { Directive, ElementRef, inject, Input, OnChanges } from '@angular/core';
import { defaultTheme, Theme } from './theme';

@Directive({
  selector: 'button[appThemedButton]',
  standalone: false
})
export class ThemedButtonDirective implements OnChanges {
  private elementRef = inject(ElementRef);

  @Input()
  appThemedButton: Theme | '';
  @Input()
  disabled: boolean;

  get theme() {
    if (this.appThemedButton === '') {
      return defaultTheme;
    }
    return this.appThemedButton;
  }

  ngOnChanges() {
    this.elementRef.nativeElement.style.fontFamily = 'Kanit, Pridi, serif';

    if (!this.disabled) {
      this.elementRef.nativeElement.style.color = '#fff';
      this.elementRef.nativeElement.style.backgroundColor = this.theme.primaryColor;
    } else {
      this.elementRef.nativeElement.style.color = '';
      this.elementRef.nativeElement.style.backgroundColor = '';
    }
  }
}
